import { Lender } from '@nemuru-eng/js-api-client';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
export const LenderOptions = (lenders: Lender[], t: GetTextIdTranslationType) =>
  lenders.map((lender) => ({
    value: lender.id,
    display: t(lender.name.toLowerCase()) || lender.name.toLowerCase(),
  }));
